import { Component, Input, OnInit } from '@angular/core';
import { IBrandResources } from 'src/app/domain/interfaces/brand/interface-brand-resources';
import { HeaderType } from 'src/app/domain/interfaces/header/header-type-enum';
import { IHeaderStyles } from 'src/app/domain/interfaces/views/interface-header-styles';

@Component({
  selector: 'app-header-basic',
  templateUrl: './header-basic.component.html',
  styleUrls: ['./header-basic.component.scss']
})
export class HeaderBasicComponent implements OnInit {
  @Input() headerType = HeaderType.Basic;
  public HeaderType = HeaderType;
  @Input() headerStyles!: IHeaderStyles;
  @Input() showClassVerify?: boolean = false;
  @Input() brandResources!: IBrandResources;
  
  constructor() { }

  ngOnInit(): void {
  }

}
